import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
/**
 * Default permissions configuration for B3 provider
 */
const DEFAULT_PERMISSIONS = {
    approvedTargets: ["0xa8e42121e318e3D3BeD7f5969AF6D360045317DD"],
    nativeTokenLimitPerTransaction: 0.1,
    startDate: new Date(),
    endDate: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365), // 1 year from now
};
const B3ConfigContext = createContext(null);
export function B3ConfigProvider({ children, accountOverride, environment = "development", defaultPermissions = DEFAULT_PERMISSIONS, automaticallySetFirstEoa = false, theme = "light", clientType = "rest", partnerId, stripePublishableKey, createClientReferenceId, authStrategy = "thirdweb", }) {
    return (_jsx(B3ConfigContext.Provider, { value: {
            accountOverride,
            environment,
            defaultPermissions,
            automaticallySetFirstEoa,
            theme,
            clientType,
            partnerId,
            stripePublishableKey,
            createClientReferenceId,
            authStrategy,
        }, children: children }));
}
export function useB3Config() {
    const context = useContext(B3ConfigContext);
    if (!context) {
        throw new Error("useB3Config must be used within a B3ConfigProvider");
    }
    return context;
}
